<div class="tc-content">
  <ng-content></ng-content>
</div>
